import React, { useMemo, useState } from 'react'
import { AutoComplete as AntAutoComplete, Input } from 'antd'
import PropTypes from 'prop-types'
import { useParams } from 'react-router'

import { useAutoComplete } from 'admin/lib/Api/queries'

export const AutoCompleteInput = React.forwardRef(
  ({ children = <Input />, name, alias, ...props }, ref) => {
    const { moduleName } = useParams()
    const [isFocused, setFocused] = useState(false)
    const [completions, requestCompletions] = useAutoComplete({
      moduleName,
      fieldName: name,
      alias: alias
    })

    const child = React.Children.only(children)

    const options = useMemo(() => {
      return completions.map(c => ({ label: c, value: c }))
    }, [completions])

    return (
      <AntAutoComplete
        options={options}
        onSearch={value => {
          setFocused(true)
          requestCompletions(value)
        }}
        onKeyDown={e => {
          if (e.key == 'Tab') {
            setFocused(false)
            requestCompletions(false)
          }
        }}
        onBlur={() => {
          if (isFocused) {
            setFocused(false)
            requestCompletions(false)
          }
        }}
        style={{ display: 'block' }}
        name={name}
        {...props}
        ref={ref}
      >
        {React.cloneElement(child, { name })}
      </AntAutoComplete>
    )
  }
)

AutoCompleteInput.displayName = 'AutoCompleteInput'

AutoCompleteInput.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node
}
